<template>
  <chart-card :chart-data="data"
              :chart-id="chartId"
              :chart-height="250"
              :chart-options="{ responsive: true, maintainAspectRatio: false }"
              :pdfPrint="pdfPrint"
              :alertActive="alertActive"
              chart-title="">
    <div slot="title-label" class="p-badge badge-pill mt-1" :class="[getBackgroundClass(badgeValue)]">
        <span v-if="badgeValue">{{ badgeValue | formatNumber(1) }}</span>
        <span v-else>{{ '-' }}</span>
    </div>
    <template slot="footer-title">
      {{ title }}
    </template>
    <template slot="footer-right">
<!--      <router-link v-if="link" :to="link">-->
        <p-button v-if="link && isUserOwner" round class="mr-1 btn-team-member-list" type="primary" size="sm"
                  icon @click="clicked">
          <i v-if="icon" :class="icon" />
        </p-button>
<!--      </router-link>-->
    </template>
  </chart-card>
</template>

<script>
  import ChartCard from 'src/components/UIComponents/Cards/ChartCard'
  import { Badge, Button } from 'src/components/UIComponents'
  import { getBackgroundClass } from '../../../util/colors'

  export default {
    name: 'BasicChart',
    components: {
      ChartCard,
      Badge,
      [Button.name]: Button
    },
    props: {
      data: Object,
      title: String,
      badgeValue: [Number, String],
      icon: String,
      link: String,
      isUserOwner: Boolean,
      pdfPrint: Boolean,
      alertActive: Number
    },
    data () {
      return {
        chartId: `chart-id-${Date.now()}`
      }
    },
    methods: {
      getBackgroundClass,
      clicked() {
        this.$emit('clicked')
      }
    }
  }
</script>
